export default {"src":"/_next/static/media/t-shirt.1754a0f0.svg","height":20,"width":20};